<template>
  <roe-error-message :field="design.auto_increase_effective_date">
    <datepicker
      v-model="design.$model.auto_increase_effective_date"
      :disabled-dates="disableDates"
    ></datepicker>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
import { AutoIncreaseMixin } from "@/components/_shared/inputs/design/_mixins";
import Datepicker from "vuejs-datepicker";
export default {
  name: "RoeAutoIncreaseEffectiveDateInput",
  components: { Datepicker, RoeErrorMessage },
  mixins: [AutoIncreaseMixin],
  props: {
    design: Object
  },
  mounted() {
    this.design.$model.auto_increase_effective_date =
      this.design.$model.auto_increase_effective_date || new Date();
  },
  computed: {
    disableDates() {
      return {
        from: new Date()
      };
    }
  }
};
</script>
